module.exports = __webpack_public_path__ + "img/藕节.29ec4ed8.jpg";